import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Commercial from "./components/Commercial";
import Residential from "./components/Residential";
import Contact from "./components/Contact";
import Booking from "./components/Booking";
import Footer from "./components/Footer";
import { HelmetProvider } from "react-helmet-async";
import { FaWhatsapp } from "react-icons/fa";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <Services />
                  <About />
                  <Commercial />
                  <Residential />
                  <Contact />
                </>
              }
            />
            <Route path="/commercial" element={<Commercial />} />
            <Route path="/residential" element={<Residential />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/booking" element={<Booking />} />
          </Routes>
          <Footer />

          {/* Floating WhatsApp Button */}
          <a
            href="https://wa.me/923054743725"
            target="_blank"
            rel="noopener noreferrer"
            className="position-fixed"
            style={{
              bottom: "20px",
              right: "20px",
              width: "60px",
              height: "60px",
              backgroundColor: "#25D366",
              color: "white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
              textDecoration: "none",
              boxShadow: "0 4px 12px rgba(37, 211, 102, 0.4)",
              zIndex: 1000,
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.1)";
              e.target.style.boxShadow = "0 6px 20px rgba(37, 211, 102, 0.6)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.boxShadow = "0 4px 12px rgba(37, 211, 102, 0.4)";
            }}
            title="Chat on WhatsApp"
          >
            <FaWhatsapp />
          </a>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
